import { Stack, Typography } from '@mui/material';
import { IntermediateCsatFuncValue } from 'generated/graphql';

interface CSATFormulaDefinitionParams {
  csat: IntermediateCsatFuncValue & {
    value: number;
  };
}

export function CSATFormulaDefinition({ csat }: CSATFormulaDefinitionParams) {
  return (
    <Stack>
      <Typography variant="caption">
        Customer Satisfaction Score (CSAT):{' '}
        <Typography component="span" variant="inherit" fontWeight="bold">
          {csat.value}
        </Typography>
      </Typography>
      <Typography variant="caption">
        {`(Total no. of satisfied responses (CSAT rating > 4) `}
        <Typography component="span" variant="inherit" fontWeight="bold">
          {csat.satisfiedResponses}
        </Typography>
        {` ÷ Total no. of responses `}
        <Typography component="span" variant="inherit" fontWeight="bold">
          {csat.totalResponses}
        </Typography>
        {`) x 100`}
      </Typography>
    </Stack>
  );
}
